var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExacta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.969,
    height: 12.969
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-exacta_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#737c81",
    d: "M0 0h16.969v12.969H0z",
    "data-name": "Rectangle 1412"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Exacta"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    clipPath: "url(#icon-exacta_svg__a)",
    "data-name": "Group 3330"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffb100",
    strokeLinejoin: "round",
    d: "M.75 2.3A1.547 1.547 0 102.3.75 1.547 1.547 0 00.75 2.3",
    "data-name": "Path 5723"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aeb7bc",
    strokeLinejoin: "round",
    d: "M.75 10.672A1.547 1.547 0 102.3 9.125a1.547 1.547 0 00-1.55 1.547",
    "data-name": "Path 5724"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 2.297h9.313",
    "data-name": "Path 5729"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    strokeLinejoin: "round",
    d: "M6.906 10.672h9.313",
    "data-name": "Line 1250"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi45NjkiIGhlaWdodD0iMTIuOTY5Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzczN2M4MSIgZD0iTTAgMGgxNi45Njl2MTIuOTY5SDB6IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNDEyIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJJY29uIC0gRXhhY3RhIj48ZyBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41IiBjbGlwLXBhdGg9InVybCgjYSkiIGRhdGEtbmFtZT0iR3JvdXAgMzMzMCI+PHBhdGggc3Ryb2tlPSIjZmZiMTAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNLjc1IDIuM0ExLjU0NyAxLjU0NyAwIDEgMCAyLjMuNzUgMS41NDcgMS41NDcgMCAwIDAgLjc1IDIuMyIgZGF0YS1uYW1lPSJQYXRoIDU3MjMiLz48cGF0aCBzdHJva2U9IiNhZWI3YmMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik0uNzUgMTAuNjcyQTEuNTQ3IDEuNTQ3IDAgMSAwIDIuMyA5LjEyNWExLjU0NyAxLjU0NyAwIDAgMC0xLjU1IDEuNTQ3IiBkYXRhLW5hbWU9IlBhdGggNTcyNCIvPjxwYXRoIHN0cm9rZT0iIzczN2M4MSIgZD0iTTYuOTA2IDIuMjk3aDkuMzEzIiBkYXRhLW5hbWU9IlBhdGggNTcyOSIvPjxwYXRoIHN0cm9rZT0iIzczN2M4MSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTYuOTA2IDEwLjY3Mmg5LjMxMyIgZGF0YS1uYW1lPSJMaW5lIDEyNTAiLz48L2c+PC9nPjwvc3ZnPgo=";
export { SvgIconExacta as ReactComponent };